import { TUpdateOrganizationFormData, TUpdateOrganizationReqDto } from "@/api/services/admin/organization/dtos/update-organization.dto";

export const convertUpdateOrganizationFormData = (formData: TUpdateOrganizationFormData): TUpdateOrganizationReqDto => {
  return {
    ...formData,
    productIds: (formData.productIds ?? []).map(Number),
    // The 担当者 Select holds the user id as a string (empty = cleared → null); send a number to the API.
    personInChargeId: formData.personInChargeId ? Number(formData.personInChargeId) : null,
  };
};
